export const HOME = '/';
export const CECI = '/ceci';
export const MANAGE_IDEAS = '/manage-ideas';
export const PAYMENT = '/payment';